import api from './index';

export const authAPI = {
  // Register
  register: (userData) => {
    return api.post('/users/register', userData);
  },
  
  // Login
  login: (credentials) => {
    return api.post('/users/login', credentials);
  },
  
  // Logout
  logout: () => {
    return api.post('/users/logout');
  },
  
  // Get profile
  getProfile: () => {
    return api.get('/users/auth');
  },
  
  // Update profile
  updateProfile: (data) => {
    return api.patch('/users/auth', data);
  },
  
  // Change password
  changePassword: (data) => {
    return api.post('/users/change-password', data);
  }
};